import { Component, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { CardTaskComponent } from './card-task/card-task.component';
import { SearchService } from './search.service';
import { DataTask, SearchData } from 'app/models/search-response.model';
import { Observable, Subject, takeUntil } from 'rxjs';
import {MatBadgeModule} from '@angular/material/badge';
import { SearchParams } from './search-params';
import { ActivatedRoute } from '@angular/router';
import { environment as env } from 'environments/environments';
import { CommonModule } from '@angular/common';
import { CardBienesCulturalesComponent } from "./card-bienes-culturales/card-bienes.component";
import { CardColeccionistaComponent } from './card-coleccionista/card-coleccionista.component';

@Component({
    selector: 'search-componente',
    templateUrl: 'search.component.html',
    imports: [
    MatTabsModule,
    MatBadgeModule,
    CommonModule,
    //components
    CardTaskComponent,
    CardBienesCulturalesComponent,
    CardColeccionistaComponent
]
})

export class SearchComponent implements OnInit {

    tasks$:Observable<SearchData>
    solicitudes:DataTask
    gestiones:DataTask
    tipoGestiones:number
    tipoSolicitudes:number

    constructor(private SearchService: SearchService, private activeroute: ActivatedRoute) { 
        this.tasks$= this.SearchService.task$

        this.tasks$.subscribe((data) => {
            if (data) {
              this.solicitudes = data.solicitudes;
              this.gestiones = data.gestiones;
            }
          });
        
        this.tipoGestiones= env.TIPOLOGIA_ID_GESTIONES
        this.tipoSolicitudes= env.TIPOLOGIA_ID_SOLICITUDES

    }

    ngOnInit() {}

}